<template>
  <div class="page with-header page-no-flex">
    <div class="page-inner" :class="{'page-inner-full':!menuOpen}">
      <div class="gradient-theme md-card md-card-header md-card-header-theme new-head-fixed" v-if="!loggedout">
        <div class="menu pr-3">
          <router-link to="home">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="feather  trans"><polyline points="15 18 9 12 15 6"></polyline></svg>
          </router-link>
        </div>
        <h3 class="title new-head-title"><strong>Logout Confirmation</strong></h3>
      </div>
      <div style="margin-top:50px" v-if="!loggedout"></div>


      <div class="header hide" v-if="!loggedout">
        <div class="menu">
          <router-link to="home">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="feather theme trans"><polyline points="15 18 9 12 15 6"></polyline></svg>
          </router-link>
        </div>
        <div class="title pl-3" >Logout Confirmation</div>
      </div>
      <div class="main md-scrollbar p-3 px-3 px-md-4">
        <div class="md-card">
          <div class="md-card-content">
            <div class="form-style-8">
              <p class="center" v-if="!loggedout"><button type="button" @click="logout()">Logout now</button></p>
              <h4 class="center" v-if="loggedout">You have successfully logged out
                <br>
                <br>
                <br>
                <button type="button" @click="login()">Login</button>
              </h4>
            </div>

            <h2 class="center pt-5">Visit our Shopping Malls</h2>
            <ul class="px-4 form-style-8" style="display:flex;flex-wrap: wrap">
              <div class="p-3" style="flex-grow:1">
                <div class="pt-3 pt-md-0"><small>SUNWAY</small></div>
                <strong><a href="https://www.sunwaypyramid.com/" target="_blank" class="link ">PYRAMID MALL</a></strong>
              </div>
              <div class="p-3" style="flex-grow:1">
                <div class="pt-3"><small>SUNWAY</small></div>
                <strong>
                  <a href="https://www.sunwayputramall.com/" target="_blank" class="link">PUTRA MALL</a>
                </strong>
              </div>
              <div class="p-3" style="flex-grow:1">
                <div class="pt-3"><small>SUNWAY</small></div>
                <strong>
                  <a href="https://www.sunwaygizamall.com/" target="_blank" class="link">GIZA MALL</a>
                </strong>
              </div>
              <div class="p-3" style="flex-grow:1">
                <div class="pt-3"><small>SUNWAY</small></div>
                <strong>
                  <a href="https://www.sunwayvelocitymall.com/" target="_blank" class="link">VELOCITY MALL</a>
                </strong>
              </div>
              <div class="p-3" style="flex-grow:1">
                <div class="pt-3"><small>SUNWAY</small></div>
                <strong>
                  <a href="https://www.sunwaycarnival.com/" target="_blank" class="link">CARNIVAL</a>
                </strong>
              </div>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue, Prop } from "vue-property-decorator";
import Login from "../components/Login.vue";
import Header from "../components/common/Header.vue";
import { cacheSrv } from "./../services/cache";
import store from "./../store";
import router from "@/router";
import SideMenu from "@/components/common/SideMenu.vue";

@Component({
  components: {
    Header,
    SideMenu
  }
})
export default class LogoutPage extends Vue {
  CACHE_KEY_PROFILE = this.$store.getters.tokenKeys.CACHE_KEY_PROFILE;
  CACHE_KEY_TOKEN = this.$store.getters.tokenKeys.CACHE_KEY_TOKEN;
  loggedout = false;
  constructor() {
    super();
  }
  created() {
    let token = cacheSrv.cached(this.CACHE_KEY_TOKEN);
    if (!token) {
      //this.disableMenu()
      this.loggedout = true;
    }
  }
  get menuOpen() {
    return store.state.menu.open;
  }
  disableMenu() {
    //store.commit("disableMenu", true);
    store.commit("setMenu", false);
  }
  login() {
    router.push("login");
  }
  logout() {
    cacheSrv.remove(this.CACHE_KEY_PROFILE);
    cacheSrv.remove(this.CACHE_KEY_TOKEN);
    cacheSrv.remove("answers");
    store.commit(`logout`);
    //router.push("login");
    this.loggedout = true;
    //this.disableMenu()
  }
}
</script>
